/**
 * Helpers to compute super properties (account_type, surface, platform).
 */
import { Capacitor } from '@capacitor/core';
import type { AccountType, Surface, SuperProperties } from './types';

export function detectPlatform(): SuperProperties['app_platform'] {
  if (!Capacitor.isNativePlatform()) return 'web';
  const p = Capacitor.getPlatform();
  if (p === 'ios') return 'ios';
  if (p === 'android') return 'android';
  return 'web';
}

export function detectSurface(pathname: string): Surface {
  if (pathname.startsWith('/app/caregiver') || pathname.startsWith('/app/agenda')) return 'caregiver_app';
  if (pathname.startsWith('/app/company') || pathname.startsWith('/app/team') || pathname.startsWith('/company')) return 'company_console';
  if (pathname.startsWith('/app')) return 'app';
  return 'landing';
}

export interface AccountTypeInput {
  hasUser: boolean;
  isCompanyMember: boolean;
  companyRole?: 'manager' | 'coordinator' | 'caregiver' | null;
  isOwner: boolean;
  isCaregiver: boolean;
}

export function resolveAccountType(input: AccountTypeInput): AccountType {
  if (!input.hasUser) return 'anonymous';
  if (input.isCompanyMember) {
    if (input.companyRole === 'manager') return 'b2b_manager';
    if (input.companyRole === 'coordinator') return 'b2b_coordinator';
    return 'b2b_caregiver';
  }
  if (input.isOwner) return 'b2c_owner';
  if (input.isCaregiver) return 'b2c_caregiver';
  return 'b2c_owner';
}
